import { defineComponent as _defineComponent } from 'vue'
interface Props {
    size?: 's' | 'm' | 'l',
    type?: 'outline' | 'tonal',
    staticIconActiveColor?: boolean,
    isActive?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Simple',
  props: {
    size: { default: 's' },
    type: { default: 'tonal' },
    staticIconActiveColor: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false }
  },
  setup(__props: any) {




return { __sfc: true, }
}

})